import styles from "@styles/containers/cdp/audiences.module.scss";
import { useEffect } from "react";

import * as echarts from "echarts";

const months = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

export default function YearChart({ data }) {
  useEffect(() => {
    const yearChartDOM = document.getElementById("year-chart");
    const yearChart = echarts.init(yearChartDOM, null, {
      renderer: "svg",
    });
    
    const options = {
      tooltip: {
        show: false,
      },
      xAxis: {
        type: "category",
        data: (data || []).map(d => `${months[d.month - 1]}/${d.year}` ),
      },
      yAxis: {
        splitLine: {
          show: false,
        },
        type: "value",
      },
      series: [
        {
          name: "",
          type: "line",
          data: (data || []).map(d => d.customers),
          showSymbol: true,
          lineStyle: {
            width: 2,
            color: "#FFC741",
          },
          markPoint: {
            symbol: "roundRect",
            symbolSize: 35,
            label: {
              color: "#fff",
            },
            data: (data || []).map((d, i) => ({ coord: [i, d.customers], value: d.customers })),
          },
        },
      ],
    };

    options && yearChart.setOption(options);
  }, [data]);

  return (
    <div className={styles.yearChartContainer}>
      <div className={styles.chartHeader}>
        <p>Últimos 12 meses</p>
      </div>
      <div
        id="year-chart"
        style={{ width: "100%", height: "calc(100% - 35px)" }}
      />
    </div>
  );
}
